//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import InTitle from "@/views/stencil/components/title";
import Model from "./components/info/model";
import Basefoot from "./components/common/Basefoot";
import InstructionProtocol from "@/views/stencil/components/instructionProtocol";
import NewProtocol from "@/views/stencil/components/newProtocol";
import { store } from "@/observable/store";
import { InsurStore, InsurMutations } from "./store";
import { insuranceForm } from "@/model/javaApi/detail.js";
import mixinTxrNewWeb, { privateKeyMap } from "@/utils/mixin/mixinTxrNewWeb";
import mixinVerify from "@/utils/mixin/mixinVerify";
import { priceFormatter } from "./components/_utils";
import { get } from "lodash";
import Schemes from "./components/Schemes.vue";

export default {
  name: "detailInfo",
  mixins: [mixinTxrNewWeb, mixinVerify],
  data() {
    return {
      from: {},
      load: true,
      protocolInfo: {},
      selectedScheme: null,
    };
  },
  components: {
    Model,
    Basefoot,
    InstructionProtocol,
    NewProtocol,
    InTitle,
    Schemes,
  },
  activated() {
    // 重置组件内部状态
    this.from = {};
    this.protocolInfo = {};
    // 重置必要的全局数据
    InsurMutations.resetState();
    // 获取填单页展示信息
    this.getInfo();
  },
  beforeRouteLeave(to, form, next) {
    next();
  },
  computed: {
    // 渠道商品code
    channelCommodityCode() {
      return this.$route.query.channelCommodityCode;
    },
    // 渠道商品code
    channelCommodityName() {
      return this.$route.query.channelCommodityName;
    },
    // 氧分呗唯一流水号
    yfbInsuranceUniqueId(){
      return this.$route.query.yfbInsuranceUniqueId;
    },
    // 保障方案计划
    schemes() {
      const schemes = get(this.from, "schemes");
      return Array.isArray(schemes) ? schemes : [];
    },
    // 获取价格
    price() {
      const salePrice = get(this.selectedScheme, "salePrice");
      if (salePrice != null) {
        return priceFormatter(salePrice);
      }
      const price = get(this.selectedScheme, "price");
      if (price != null) {
        return priceFormatter(price);
      }
      return priceFormatter(get(this.from, "costRateInfo.price"));
    },
    // 附加协议Code
    insureCode() {
      let str = "";
      let list = InsurStore.resultCount.selectItems;
      list.forEach((item) => {
        if (item.optionCode) {
          str += item.optionCode + ",";
        }
      });
      if (str) {
        str = str.substring(0, str.length - 1);
      }
      return str;
    },
    materielMap() {
      return InsurStore.insuranceform.materielMap;
    },
  },
  mounted() {},
  methods: {
    submitClick() {
      this.$refs.InstructionProtocol.selectFlag = true;
      this.btnClick();
    },
    // 点击确认
    btnClick() {
      const data = {
        elements: InsurStore.fromPageData,
        price: this.price,
        channelCommodityCode: this.channelCommodityCode,
        traceId: store.TXoption.bizKey,
        ch: this.$route.query.ch || "",
        schemeCode: get(this.selectedScheme, "schemeCode"),
        yfbInsuranceUniqueId: this.yfbInsuranceUniqueId, //氧分呗唯一流水号
      };
      this.protocolInfo = {
        productName: this.channelCommodityName,
        buyerName: get(InsurStore.fromPageData, ["BUYER_NAME", "value"]),
        insuredName:
          get(InsurStore.fromPageData, ["INSURED_NAME", "value"]) ||
          get(InsurStore.fromPageData, ["BUYER_NAME", "value"]),
      };
      // 统一核保
      this.verification(data)
        .then((res) => {
          this.STATISTICS_CONFIG.insur_insurinfoinput_submit_click({
            ex: { status: "pass" },
          });

          this.goConfirm();
        })
        .catch((res) => {
          this.STATISTICS_CONFIG.insur_insurinfoinput_submit_click({
            ex: { status: "fail" },
          });
        });
    },
    // 跳转重要信息确认页
    goConfirm() {
      this.$router.push({
        path: "/installmentConfirm",
        query: {
          commodityCode: this.channelCommodityCode,
          insureCode: this.insureCode,
          productCode: this.$route.query.productCode,
          flag: "postdisable",
        },
      });
    },
    // 获取保险信息
    getInfo() {
      insuranceForm({ 
        channelCommodityCode: this.channelCommodityCode,
        yfbInsuranceUniqueId: this.$route.query.yfbInsuranceUniqueId
      })
        .then((res) => {
          console.log("填单页结果:", res);
          this.from = res;
          InsurMutations.insuranceform(res);
          /** 设置默认选中的方案 */
          const schemes = get(res, "schemes");
          if (Array.isArray(schemes) && schemes.length > 0) {
            const schemeCodeFromQuery = this.$route.query.schemeCode;
            let scheme = null;
            if (schemeCodeFromQuery) {
              scheme = schemes.find(
                (item) => item.schemeCode === schemeCodeFromQuery
              );
            }
            if (!scheme) {
              scheme = schemes[0];
            }
            const schemeName = scheme.schemeName;
            this.STATISTICS_CONFIG.insur_insurinfoinput_page({
              ex: { scheme: schemeName },
            });
            this.selectedScheme = scheme;
          }
          this.$nextTick(() => {
            // 回溯视频
            const productCode = get(res, "productCode");
            this.infoTX(
              productCode && privateKeyMap[productCode]
                ? productCode
                : this.channelCommodityCode
            );
          });
        })
        .finally(() => {
          this.load = true;
        });
    },
    custUrlClick() {
      this.STATISTICS_CONFIG.insur_insurinfoinput_contactonline_click();
    },
    onSchemeChange(scheme) {
      this.selectedScheme = scheme;
    },
  },
};
